import styles from "./PickADay.module.css";
import React, { useCallback, useEffect, useMemo } from "react";
import { type Day, type Month, type MonthInfo } from "../../types/date";
import { monthsNames, type Locale } from "./text.i18n";
import clsx from "clsx";
import { PickADayCalendar } from "./PickADayCalendar";
import { PickADayMonthSelector } from "./PickADayMonthSelector";
import { PickADayYearSelector } from "./PickADayYearSelector";
import { PickADayContextProvider, usePickADayContext } from "./PickADayContext";

interface Date {
  day: Day;
  month: Month;
  year: number;
}

export interface PickADayProps {
  date: Date;
  onChangeDate: (date: Date) => void;
  locale: Locale;
  flip?: boolean;
}

const PickADay: React.FC<PickADayProps> = ({
  date,
  onChangeDate,
  locale,
  flip,
}) => {
  const monthsNamesList: MonthInfo[] = useMemo(
    () =>
      Object.keys(monthsNames).map((item) => ({
        name: monthsNames[item][locale],
        id: Number(item) as Month,
      })),
    [locale]
  );

  const { year, day, month, setDay, setMonth, setYear } = usePickADayContext();

  useEffect(() => {
    setDay(date.day);
    setMonth(date.month);
    setYear(date.year);
  }, [date, setDay, setMonth, setYear]);

  const handleChange = useCallback(() => {
    onChangeDate({ year, day, month });
  }, [year, month, day, onChangeDate]);

  return (
    <div className={clsx(styles.PickADay, { [styles.PickADay_flip]: flip })}>
      <div className={styles.PickADay__view}>
        <PickADayCalendar locale={locale} monthsNamesList={monthsNamesList} />
      </div>
      <div className={styles.PickADay__settings}>
        <PickADayMonthSelector monthsNamesList={monthsNamesList} />

        <PickADayYearSelector />
        <button
          className={styles.PickADay__confirmButton}
          onClick={handleChange}
        >
          Готово
        </button>
      </div>
    </div>
  );
};

const PickADayWithProvider: React.FC<PickADayProps> = (props) => {
  return (
    <PickADayContextProvider>
      <PickADay {...props} />
    </PickADayContextProvider>
  );
};
export default PickADayWithProvider;
